import { render, staticRenderFns } from "./TokenInput.vue?vue&type=template&id=47501742"
import script from "./TokenInput.vue?vue&type=script&lang=js"
export * from "./TokenInput.vue?vue&type=script&lang=js"
import style0 from "./TokenInput.vue?vue&type=style&index=0&id=47501742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports